import React from 'react';
import { TEMA } from '../theme';

interface PlaceholderProps {
  titel: string;
  modul?: string;
}

export default function Placeholder({ titel, modul = 'ANBUD' }: PlaceholderProps) {
  return (
    <div>
      <p style={{
        fontFamily: "'IBM Plex Mono', monospace",
        fontSize: '11px',
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        color: TEMA.accent,
        margin: '0 0 10px',
      }}>
        {modul}
      </p>
      <h1 style={{ fontFamily: "'Fraunces', serif", fontSize: '26px', color: TEMA.ink, margin: '0 0 24px' }}>{titel}</h1>

      <div style={{
        background: TEMA.bgPanel,
        border: `1px solid ${TEMA.border}`,
        borderRadius: '8px',
        padding: '32px',
        textAlign: 'center',
      }}>
        <p style={{ color: TEMA.inkFaint, fontFamily: "'Inter', sans-serif", fontSize: '14px', margin: 0 }}>
          Den här modulen är under utveckling och kommer snart.
        </p>
      </div>
    </div>
  );
}